var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"popupCloseButton",on:{"click":function($event){return _vm.$emit("clicked")}}},[_c('img',{staticClass:"popupCloseButton__img",attrs:{"src":require("../../assets/Close_Button.svg")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }